// Initialize Firebase

import * as firebase from "firebase/app"
import 'firebase/analytics'
import 'firebase/functions'

// production code for console.log
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  console.log("Development");
} else {
  console.log("Production");
  console.log = () => {};

}
const config = {
  apiKey: "AIzaSyDnEcRZGuHz205IlJFenmYCSvIqGjoUrmo",
  authDomain: "proliantepycleague2025.firebaseapp.com",
  databaseURL: "https://proliantepycleague2025-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "proliantepycleague2025",
  storageBucket: "proliantepycleague2025.firebasestorage.app",
  messagingSenderId: "509532833238",
  appId: "1:509532833238:web:4e7d184e420b1649fc9077",
  measurementId: "G-69BB76ZC47"
};
firebase.initializeApp(config)
firebase.analytics();

